import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getLocalPackageBooking,
  getLocalPriceCode,
  getStoreLocalData,
  getUserData,
  setLocalPackageBooking,
  setLocalPriceCode,
} from "../../utils/localStorage";
import { packageBooking } from "../../services/BookNewOrder/BookNewOrder";
import { getPriceCode } from "../../services/StorePriceCode/getPriceCode";
import PriceCodeNotFound from "./PriceCodeNotFound";
import CustomerPackagesModal from "../CartComponent/CustomerPackagesModal";
import { storeCustomerGetInfo } from "../../services/CustomerInfo/CustomerInfo";
import { getAllCustomerPackageOffer } from "../../services/CustomerPackageOffer/CustomerPackageOffer";
import { CustomerOrderPackageLog } from "../../services/PackageLog/PackageLog";
import { formatDate } from "../../constants/FormateDate";

const BRAND_COLOR = "#1752AA";

const TABS = [
  { key: "general", label: "Book By piece", sub: "By piece", icon: "pi-shopping-bag", color: "#1752AA", tint: "#E3EDFC" },
  { key: "kg", label: "Book By KG", sub: "By kg", icon: "pi-box", color: "#0B7A53", tint: "#DFF5EC" },
  { key: "carryForward", label: "Book By Subscription", sub: "Subscription", icon: "pi-sync", color: "#6236C9", tint: "#EEE8FC" },
  { key: "other", label: "Others", sub: "Other plans", icon: "pi-th-large", color: "#C2520F", tint: "#FDEBDD" },
];

const TAB_BY_KEY = Object.fromEntries(TABS.map((tab) => [tab.key, tab]));

const TAB_HINTS = {
  general: "Booked by piece. Several price lists are active — pick one to start.",
  kg: "Booked by kg. Pick a package to book against.",
  carryForward: "Booked by subscription. Pick a package to book against.",
  other: "All remaining packages. Pick a package to book against.",
};

const BookNewOrderNew = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const { storeCustomerId, navigateThrough } = location.state || {}; // Fallback to prevent undefined errors
  const { storeData, userProfileRole, brandProfileData, userProfileData } =
    getUserData();
  const { storeLocalData } = getStoreLocalData();
  const storeId = storeData.id;
  const userRole = userProfileRole;
  const enabledMultiPriceList = storeData.enabledMultiPriceList;
  const storeCarryForward = storeData.packageCarryForward;
  const brandCarryForward = brandProfileData.packageCarryForward;
  const brandId = userProfileData.brandId;
  const brandCarryForwardApplyOn = brandProfileData.carryForwardApplyOn;
  const enabledCustomerBillingWithDefaultPrice = storeData.enabledCustomerBillingWithDefaultPrice;

  const [customerData, setCustomerData] = useState({});
  const customerSelectedPriceId = customerData?.priceId;

  const [defaultPriceData, setDefaultPriceData] = useState({});
  const [packageData, setPackageData] = useState([]);
  const [activeTab, setActiveTab] = useState(null);

  const [priceCodeModalVisible, setPriceCodeModalVisible] = useState(false);
  const [customerPackagesModalVisible, setCustomerPackagesModalVisible] =
    useState(false);

  const fetchStoreCustomerInfo = async () => {
    try {
      const response = await storeCustomerGetInfo(storeCustomerId, storeId);
      if (!response.data.error) {
        const Res = response.data;
        setCustomerData(Res);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchDefaultPrice = async () => {
    try {
      const response = await getPriceCode(storeId);
      if (!response.data.error) {
        const Res = response.data;
        setDefaultPriceData(Res.storePrices);
        setLocalPriceCode(Res.storePrices);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalDefaultPrice = async () => {
    const { priceCode } = getLocalPriceCode();
    if (priceCode && Object.keys(priceCode).length > 0) {
      setDefaultPriceData(priceCode);
    } else {
      await fetchDefaultPrice();
    }
  };

  const fetchPackage = async () => {
    try {
      const response = await packageBooking(storeId);
      if (!response.data.error) {
        setPackageData(response.data);
        setLocalPackageBooking(response.data);
      }
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const fetchLocalPackage = async () => {
    const { packageBooking } = getLocalPackageBooking();
    if (packageBooking && Object.keys(packageBooking).length > 0) {
      setPackageData(packageBooking);
    } else {
      await fetchPackage();
    }
  };

  useEffect(() => {
    fetchStoreCustomerInfo();
    fetchLocalDefaultPrice();
    fetchLocalPackage();
  }, []);

  const [customerPackageOfferData, setCustomerPackageOfferData] = useState([]);
    const [customerOrderPackageLogAllData, setCustomerOrderPackageLogAllData] = useState([])
    const [
        customerStorePackageOfferReSubscribeModalVisible,
        setCustomerStorePackageOfferReSubscribeModalVisible,
      ] = useState("");
    
      const [
        customerStorePackageOfferReSubscribeModalData,
        setCustomerStorePackageOfferReSubscribeModalData,
      ] = useState({});

   const fetchCustomerPackageOfferList = (data) => {
      getAllCustomerPackageOffer(brandId, data)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data.filter(
              (item) =>
                (item.status === "ACTIVE" || item.status === "RUNNING") &&
                item.leftDiscount > 0
            );
            setCustomerPackageOfferData(Res);
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    };


  const fetchPackageLogAllData = (data) => {
      CustomerOrderPackageLog({
        ...data,
        limit: 100,
        offset: 0,
      })
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data.filter(
              (item) =>
                item.packageDTO.status === true && item.carryForwardCount > 0
            );
            setCustomerOrderPackageLogAllData(Res);
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    };

    // Offers and carry-forward logs are only needed for subscription booking
    useEffect(() => {
      if (activeTab !== "carryForward") return;

      const requestData = {
        statusIn: ["ACTIVE", "RUNNING",],
        brandId: brandId,
        storeCustomerId: [storeCustomerId],
      };
  
      fetchCustomerPackageOfferList(requestData);
  
      const packageLogData = {
        storeIds: [storeId],
        brandId: brandId,
        sortOrder: "desc",
        sortBy: "id",
        leftCarryForward: true,
        statusIn:
          brandCarryForwardApplyOn === "running"
            ? [
                "BOOKED",
                "INPROCESS",
                "PROCESSED",
                "IN_WAREHOUSE",
                "OUT_FOR_DELIVERY",
                "DONE",
                "DELIVERED",
              ]
            : ["DONE", "DELIVERED"], // add
        packageIdIn: [],
        storeCustomerId: storeCustomerId,
        valid: true,
      };
      fetchPackageLogAllData(packageLogData);
    }, [activeTab, customerPackagesModalVisible]);

  const handleBackButton = () => {
    if (userRole === "BY_STORE" && navigateThrough == "partialBooking") {
      navigate("/store-partial-booking");
    } else if (userRole === "BY_STORE") {
      navigate("/CustomerInfo", {
        state: {
          storeCustomerId: storeCustomerId,
        },
      });
    } else {
      navigate("/");
    }
  };

  const bookOrderNow = (priceId, componentName) => {
    navigate("/GeneralBookingSelection", {
      state: {
        priceId: priceId,
        BookingType: componentName,
        storeCustomerId: storeCustomerId,
      },
    });
  };

  // General booking goes straight to the booking page unless several price lists apply
  const handleGeneralBooking = () => {
    if (!!customerSelectedPriceId) {
      bookOrderNow(customerSelectedPriceId, "GeneralBooking");
    } else if (
      defaultPriceData.length > 1 &&
      enabledMultiPriceList &&
      !enabledCustomerBillingWithDefaultPrice
    ) {
      setActiveTab("general");
    } else if (defaultPriceData[0]?.price?.id) {
      bookOrderNow(defaultPriceData[0]?.price?.id, "GeneralBooking");
    } else {
      setPriceCodeModalVisible(true);
    }
  };

  const handleTabClick = (key) => {
    if (key === "general") {
      handleGeneralBooking();
    } else {
      setActiveTab(key);
    }
  };

  const carryForwardEnabled = brandCarryForward && storeCarryForward;
  const packages = Array.isArray(packageData) ? packageData : [];
  const isCarryForwardPackage = (item) => carryForwardEnabled && item.carryForward;
  const isKgPackage = (item) =>
    String(item.serviceUnit || "").toLowerCase() === "kg";

  // Packages the customer already has a carry-forward balance for are shown from the logs instead
  const carryForwardLogPackageIds = new Set(
    (customerOrderPackageLogAllData || []).map((log) => log?.packageDTO?.id)
  );

  const packagesByTab = {
    kg: packages.filter((item) => !isCarryForwardPackage(item) && isKgPackage(item)),
    carryForward: packages.filter(
      (item) => isCarryForwardPackage(item) && !carryForwardLogPackageIds.has(item.id)
    ),
    other: packages.filter((item) => !isCarryForwardPackage(item) && !isKgPackage(item)),
  };

  const renderTabs = () => (
    <div
      className="surface-0 sticky z-1"
      style={{ top: "3rem", borderBottom: "1px solid #E3E9F2", "--surface-0": "#fff" }}
    >
      <div
        style={{
          maxWidth: 1040,
          margin: "0 auto",
          padding: "10px 12px",
          display: "grid",
          gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
          gap: 8,
        }}
      >
        {TABS.map((tab) => {
          const active = tab.key === activeTab;
          return (
            <button
              key={tab.key}
              type="button"
              aria-pressed={active}
              onClick={() => handleTabClick(tab.key)}
              style={{
                minHeight: 76,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 6,
                textAlign: "center",
                fontFamily: "inherit",
                cursor: "pointer",
                padding: "10px 4px",
                borderRadius: 14,
                border: `1.5px solid ${active ? tab.color : tab.tint}`,
                background: active ? tab.color : tab.tint,
                color: active ? "#fff" : tab.color,
                boxShadow: active ? `0 6px 16px ${tab.color}55` : "none",
                transform: active ? "translateY(-2px)" : "none",
                transition: "all 0.15s ease",
              }}
            >
              <span
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: active ? "rgba(255,255,255,0.22)" : "#fff",
                }}
              >
                <i className={`pi ${tab.icon}`} style={{ fontSize: 16, color: active ? "#fff" : tab.color }}></i>
              </span>
              <span style={{ fontSize: 14, fontWeight: 700, lineHeight: 1.2 }}>
                {tab.label}
              </span>
              {/* <span
                style={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: active ? BRAND_COLOR : "#56657A",
                }}
              >
                {tab.sub}
              </span> */}
            </button>
          );
        })}
      </div>
    </div>
  );

  const renderRow = ({ key, title, description, right, badge, onClick }) => {
    const tab = TAB_BY_KEY[activeTab];
    return (
    <button
      key={key}
      type="button"
      onClick={onClick}
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "14px 16px",
        borderRadius: 14,
        border: "1px solid #E3E9F2",
        background: "#fff",
        cursor: "pointer",
        fontFamily: "inherit",
        textAlign: "left",
        color: "#0F1C2E",
        boxShadow: "0 1px 3px rgba(15,28,46,0.06)",
      }}
    >
      <span
        style={{
          width: 44,
          height: 44,
          flexShrink: 0,
          borderRadius: 12,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: tab.tint,
        }}
      >
        <i className={`pi ${tab.icon}`} style={{ fontSize: 18, color: tab.color }}></i>
      </span>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <span style={{ fontSize: 16, fontWeight: 600 }}>{title}</span>
          {badge}
        </span>
        {description && (
          <span style={{ display: "block", marginTop: 3, fontSize: 13, color: "#56657A" }}>
            {description}
          </span>
        )}
      </span>
      {right}
      <i className="pi pi-angle-right" style={{ fontSize: 18, color: tab.color }}></i>
    </button>
    );
  };

  const renderPriceLists = () =>
    defaultPriceData.map((item) =>
      renderRow({
        key: item.price.id,
        title: item.price.priceCode,
        description: item.price.description,
        badge: item.default === true && (
          <span
            style={{
              fontSize: 11,
              fontWeight: 700,
              padding: "3px 7px",
              borderRadius: 5,
              background: "#E6F4EF",
              color: "#0E6245",
            }}
          >
            DEFAULT
          </span>
        ),
        onClick: () => bookOrderNow(item.price.id, "GeneralBooking"),
      })
    );

  const renderPackages = (list) =>
    list.map((item) =>
      renderRow({
        key: item.price?.id ?? item.id,
        title: item.name,
        description: item.description,
        badge: isCarryForwardPackage(item) && (
          <span
            style={{
              fontSize: 11,
              fontWeight: 700,
              padding: "3px 7px",
              borderRadius: 5,
              background: "#EFEAFB",
              color: "#4A2B9B",
            }}
          >
            CF
          </span>
        ),
        right: (
          <span style={{ flexShrink: 0, fontSize: 16, fontWeight: 700, color: TAB_BY_KEY[activeTab].color }}>
            {storeLocalData?.currencySymbol} {item.amount}
          </span>
        ),
        onClick: () => bookOrderNow(item.price.id, "PackageBooking"),
      })
    );

  const formatPackageQuantity = (packageDTO, count) =>
    packageDTO?.serviceUnit === "Qty"
      ? count + " Pcs"
      : count + " " + packageDTO?.serviceUnit;

  const bookCarryForwardByKg = (packageDTO) => {
    const storePackage = packages.find((pkg) => pkg.id === packageDTO?.id);
    const priceId = storePackage?.price?.id ?? packageDTO?.price?.id;
    if (priceId) {
      bookOrderNow(priceId, "PackageBooking");
    } else {
      setPriceCodeModalVisible(true);
    }
  };

  const actionButtonStyle = (color, tint) => ({
    minHeight: 40,
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "8px 14px",
    borderRadius: 10,
    border: `1.5px solid ${color}`,
    background: tint,
    color: color,
    fontFamily: "inherit",
    fontSize: 13,
    fontWeight: 700,
    cursor: "pointer",
    whiteSpace: "nowrap",
  });

  const renderBookingActions = (onBookByKg, extraAction) => (
    <span style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
      <button
        type="button"
        onClick={() => handleGeneralBooking()}
        style={actionButtonStyle(TAB_BY_KEY.general.color, TAB_BY_KEY.general.tint)}
      >
        <i className={`pi ${TAB_BY_KEY.general.icon}`} style={{ fontSize: 13 }}></i>
        Book by Piece
      </button>
      <button
        type="button"
        onClick={onBookByKg}
        style={actionButtonStyle(TAB_BY_KEY.kg.color, TAB_BY_KEY.kg.tint)}
      >
        <i className={`pi ${TAB_BY_KEY.kg.icon}`} style={{ fontSize: 13 }}></i>
        Book by KG
      </button>
      {extraAction}
    </span>
  );

  const renderBalanceCard = ({ key, title, badge, description, amount, actions, onClick }) => {
    const tab = TAB_BY_KEY.carryForward;
    const Card = onClick ? "button" : "div";
    return (
      <Card
        key={key}
        {...(onClick && { type: "button", onClick })}
        style={{
          fontFamily: "inherit",
          textAlign: "left",
          cursor: onClick ? "pointer" : "default",
          width: "100%",
          boxSizing: "border-box",
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 12,
          padding: "14px 16px",
          borderRadius: 14,
          border: "1px solid #E3E9F2",
          background: "#fff",
          color: "#0F1C2E",
          boxShadow: "0 1px 3px rgba(15,28,46,0.06)",
        }}
      >
        <span
          style={{
            width: 44,
            height: 44,
            flexShrink: 0,
            borderRadius: 12,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: tab.tint,
          }}
        >
          <i className={`pi ${tab.icon}`} style={{ fontSize: 18, color: tab.color }}></i>
        </span>
        <span style={{ flex: "999 1 220px", minWidth: 0 }}>
          <span style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
            <span style={{ fontSize: 16, fontWeight: 600 }}>{title}</span>
            <span
              style={{
                fontSize: 11,
                fontWeight: 700,
                padding: "3px 7px",
                borderRadius: 5,
                background: "#EFEAFB",
                color: "#4A2B9B",
              }}
            >
              {badge}
            </span>
          </span>
          <span style={{ display: "block", marginTop: 3, fontSize: 13, color: "#56657A" }}>
            {description}
          </span>
        </span>
        {amount !== undefined && (
          <span style={{ flexShrink: 0, fontSize: 16, fontWeight: 700, color: tab.color }}>
            {storeLocalData?.currencySymbol} {amount}
          </span>
        )}
        {actions}
        {onClick && (
          <i className="pi pi-angle-right" style={{ fontSize: 18, color: tab.color }}></i>
        )}
      </Card>
    );
  };

  const renderPackageOffers = () =>
    customerPackageOfferData?.map((item) =>
      renderBalanceCard({
        key: item.id,
        title: item.brandPackageOffer?.name?.replace(/_/g, " "),
        badge: "OFFER",
        description: (
          <>
            Left {item.leftServiceValue} of {item.brandPackageOffer?.serviceValue} service value
            {" · "}Package value {item.brandPackageOffer?.packageValue}
            <span style={{ display: "block", marginTop: 2 }}>
              Valid {formatDate(item.validFrom)} – {formatDate(item.validTo)}
            </span>
          </>
        ),
        actions: renderBookingActions(
          () => setActiveTab("kg"),
          // userProfileRole === "BY_STORE" &&
          //   ["RUNNING", "CONSUME"].includes(item.status) && (
          //     <button
          //       type="button"
          //       onClick={() => setCustomerStorePackageOfferReSubscribeModalData(item)}
          //       style={actionButtonStyle(TAB_BY_KEY.carryForward.color, TAB_BY_KEY.carryForward.tint)}
          //     >
          //       <i className="pi pi-sync" style={{ fontSize: 13 }}></i>
          //       Re-Subscribe
          //     </button>
          //   )
        ),
      })
    );

  // One card per package, with the left quantity of all its logs added up
  const groupedCarryForwardLogs = Object.values(
    (customerOrderPackageLogAllData || []).reduce((groups, item) => {
      const groupKey = item?.packageDTO?.id ?? item.id;
      if (!groups[groupKey]) {
        groups[groupKey] = { packageDTO: item.packageDTO, leftCount: 0 };
      }
      groups[groupKey].leftCount += Number(item.carryForwardCount) || 0;
      return groups;
    }, {})
  );

  const renderCarryForwardLogs = () =>
    groupedCarryForwardLogs.map((group) =>
      renderBalanceCard({
        key: group.packageDTO?.id,
        title: group.packageDTO?.name || "N/A",
        badge: "CF",
        description: (
          <>{" · "} Quantity {group?.packageDTO?.serviceUnit === "Qty"
                                ? group.packageDTO.quantity + " Pcs"
                                : group.packageDTO.quantity +
                                  " " +
                                  group.packageDTO?.serviceUnit}
                                  {" · "}Left {formatPackageQuantity(group.packageDTO, Number(group.leftCount.toFixed(2)))} 
          </>
        ),
        amount: group.packageDTO?.amount,
        onClick: () => bookCarryForwardByKg(group.packageDTO),
      })
    );

  const renderContent = () => {
    if (!activeTab) {
      return (
        <div style={{ maxWidth: 1040, margin: "0 auto", padding: "40px 16px 32px" }}>
          <div
            style={{
              background: "#fff",
              border: "1px solid #E3E9F2",
              borderRadius: 18,
              padding: "32px 20px",
              textAlign: "center",
              boxShadow: "0 1px 3px rgba(15,28,46,0.06)",
            }}
          >
            <span
              style={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#E3EDFC",
              }}
            >
              <i className="pi pi-arrow-up" style={{ fontSize: 22, color: BRAND_COLOR }}></i>
            </span>
            <p style={{ margin: "14px 0 0", fontSize: 20, fontWeight: 700, color: BRAND_COLOR }}>
              Please select your booking type
            </p>
            <div style={{ marginTop: 14, display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 8 }}>
              {TABS.map((tab) => (
                <span
                  key={tab.key}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                    padding: "6px 12px",
                    borderRadius: 999,
                    background: tab.tint,
                    color: tab.color,
                    fontSize: 13,
                    fontWeight: 600,
                  }}
                >
                  <i className={`pi ${tab.icon}`} style={{ fontSize: 12 }}></i>
                  {tab.label}
                </span>
              ))}
            </div>
          </div>
        </div>
      );
    }
    const isGeneral = activeTab === "general";
    const list = isGeneral ? [] : packagesByTab[activeTab];
    return (
      <div style={{ maxWidth: 1040, margin: "0 auto", padding: "20px 16px 32px" }}>
        <p style={{ margin: "0 0 14px", fontSize: 14, lineHeight: 1.5, color: "#56657A" }}>
          {TAB_HINTS[activeTab]}
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {isGeneral ? renderPriceLists() : renderPackages(list)}
        </div>
        

        {activeTab === "carryForward" && customerOrderPackageLogAllData?.length > 0 && (
          <div style={{ marginTop: 10 }}>
            {/* <p style={{ margin: "0 0 10px", fontSize: 15, fontWeight: 700, color: TAB_BY_KEY.carryForward.color }}>
              Carry forward balance
            </p> */}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {renderCarryForwardLogs()}
            </div>
          </div>
        )}

        {activeTab === "carryForward" && customerPackageOfferData?.length > 0 && (
          <div style={{ marginTop: 10 }}>
            {/* <p style={{ margin: "0 0 10px", fontSize: 15, fontWeight: 700, color: TAB_BY_KEY.carryForward.color }}>
              Active offers
            </p> */}
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {renderPackageOffers()}
            </div>
          </div>
        )}
        {!isGeneral &&
          list.length === 0 &&
          !(
            activeTab === "carryForward" &&
            (customerOrderPackageLogAllData?.length > 0 || customerPackageOfferData?.length > 0)
          ) && (
          <div
            style={{
              padding: "32px 16px",
              textAlign: "center",
              background: "#fff",
              border: "1px solid #E3E9F2",
              borderRadius: 14,
              color: "#56657A",
              fontSize: 14,
            }}
          >
            No packages available in this category.
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="flex-1" style={{ background: "#F4F6FA", minHeight: "100%" }}>
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": BRAND_COLOR,
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Book New Order
              </p>
            </div>
            <div className="flex justify-content-center align-items-center mr-6">
              <div
                className="active-package-button flex-1 cursor-pointer"
                onClick={() => setCustomerPackagesModalVisible(true)}
              >
                <span className="shine" />
                Active Packages
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          pointerEvents: defaultPriceData.length === 0 ? "none" : "auto",
        }}
      >
        {renderTabs()}
        {renderContent()}
      </div>

      <div>
        <PriceCodeNotFound
          setPriceCodeModalVisible={setPriceCodeModalVisible}
          priceCodeModalVisible={priceCodeModalVisible}
        />
        {customerPackagesModalVisible && (
          <CustomerPackagesModal
            customerPackagesModalVisible={customerPackagesModalVisible}
            setCustomerPackagesModalVisible={setCustomerPackagesModalVisible}
            storeId={storeId}
            storeCustomerId={storeCustomerId}
            brandId={brandId}
            brandCarryForwardApplyOn={brandCarryForwardApplyOn}
          />
        )}
      </div>
    </div>
  );
};

export default BookNewOrderNew;
